import { CacheInterface } from 'swr';

const swrCachePrefix = 'swr-';

function getStorage(mode: 'local' | 'session') {
  return mode === 'local' ? localStorage : sessionStorage;
}

// the value of SWR could be either undefined or an object
// if you had other values you will need to check them here
// and parse it correctly (e.g. use Number for number)
function baseParser(value: string): unknown {
  return value === 'undefined' ? undefined : JSON.parse(value);
}

export function syncWithStorage(cache: CacheInterface, mode: 'local' | 'session', parser = baseParser) {
  const storage = getStorage(mode);

  // Get all key from the storage
  for (const [key, data] of Object.entries(storage)) {
    if (key.startsWith(swrCachePrefix + 'err@')) continue; // never cache errors
    if (!key.startsWith(swrCachePrefix)) continue;
    // update SWR cache with the value from the storage
    cache.set(
      key.slice(4),
      parser(data)['swrValue'],
      false // don't notify the cache change, no-one is listening yet anyway
    );
  }

  // Subscribe to SWR cache changes in the future
  return cache.subscribe(() => {
    // get all the keys in cache
    const keys = cache.keys();
    // save each key in SWR with the prefix swr-
    for (const key of keys) {
      storage.setItem(`${swrCachePrefix}${key}`, JSON.stringify({ swrValue: cache.get(key) }));
    }
  });
}
